module.exports = __webpack_public_path__ + "img/drone_01_H.76ddd797.jpg";